<template>
    <DefaultLayout>
        <div class="container">
            <div class="row pt-2">
                <!-- Breadcrumbs -->
                <div class="col-8 p-0">
                    <nav aria-label="breadcrumb">
                    <ol class="py-1 my-2 breadcrumb align-middle">
                        <li class="breadcrumb-item">
                            <a href="/" class="text-primary fw-bold">
                                {{ $t('homepage') }}
                            </a>
                        </li>
                        <li class="breadcrumb-item">
                            <a class="text-secondary fw-bold">
                                {{ $t('likes') }}
                            </a>
                        </li>
                    </ol>
                    </nav>
                </div>
                <div class="col-4 text-end"></div>
            </div>
            <div class="row rounded-3 shadow-lg px-2 py-4 bg-white fs-5 fw-semibold">
                <div class="card my-2" style="border: none;">
                    <div class="row">
                        <div class="col-md-3 ps-0">
                            <ul class="nav nav-tabs flex-column" role="tablist">
                                <li class="nav-item">
                                    <a href="" data-bs-target="#networks" data-bs-toggle="tab" role="tab"
                                        class="nav-link text-decoration-none active">
                                        {{ $t('network.networks') }}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="" data-bs-target="#media" data-bs-toggle="tab" role="tab"
                                        class="nav-link text-decoration-none">
                                        {{ $t('nav.media') }}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="" data-bs-target="#collections" data-bs-toggle="tab" role="tab"
                                        class="nav-link text-decoration-none">
                                        {{ $t('collections') }}
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a href="" data-bs-target="#courses" data-bs-toggle="tab" role="tab"
                                        class="nav-link text-decoration-none">
                                        Courses
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div class="col-md-9">
                            <div v-if="!busy" id="myTabContent" class="tab-content">
                                <div id="networks" role="tabpanel" aria-labelledby="networks-tab" class="tab-pane fade show active">
                                    <h5>{{ $t('here-you-can-quickly-access-the-networks-that-you-have-liked') }}</h5>
                                    <hr class="mb-1" style="opacity: 0.5; height: 2px;" />
                                    <table v-if="likedNetworks.length > 0" class="table border-bottom">
                                        <tbody>
                                            <tr v-for="(network, index) in likedNetworks" :key="network.id" style="border-bottom: 1px solid #5C6D80;">
                                                <td>
                                                    <router-link :to="{ name: 'network-home', params: { slug: network.slug } }" class="fw-bold">
                                                        <avatar
                                                            :size="80"
                                                            :username="network.short_name"
                                                            class="rounded float-start me-4"
                                                            :src="network.logo_image"
                                                        ></avatar>
                                                    </router-link>
                                                    <div class="float-start">
                                                        <router-link :to="{ name: 'network-home', params: { slug: network.slug } }" class="fw-bold">
                                                            {{ network.name }}
                                                        </router-link><br />
                                                        <span v-if="network.public">{{ $t('NetworkCard.public-access') }}</span>
                                                        <span v-else>{{ $t('NetworkCard.private-access') }}</span><br />
                                                        <span>{{ $t('joined') }} {{ network.joined }}</span>
                                                    </div>
                                                    <Fav class="float-end" :loading="loading" :value="true" @input="unlikeNetwork(network, index)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="pt-2">
                                        {{ $t('you-havent-liked-any-networks') }}
                                    </div>
                                </div>
                                <div id="media" role="tabpanel" aria-labelledby="media-tab" class="tab-pane fade">
                                    <h5>{{ $t('here-you-can-quickly-access-the-media-items-that-you-have-liked') }}</h5>
                                    <hr class="mb-1" style="opacity: 0.5; height: 2px;" />
                                    <table v-if="likedMedia.length > 0" class="table border-bottom">
                                        <tbody>
                                            <tr v-for="(media, index) in likedMedia" :key="media.id" style="border-bottom: 1px solid #5C6D80;">
                                                <td>
                                                    <router-link :to="{ name: 'show-media-page', params: { media_slug: media.slug } }" class="fw-bold">
                                                        <img v-if="media.video_thumbnail" :src="media.video_thumbnail" class="rounded float-start me-4" style="height: 80px; width: 100px;" />
                                                        <div v-if="media.type === 'file'" class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center rounded float-start me-4" style="height: 80px; width: 100px;">
                                                            <i :class="'fas fa-2x ' + fileIcon(media.extension)"></i>
                                                        </div>
                                                    </router-link>
                                                    <div class="float-start">
                                                        <router-link :to="{ name: 'show-media-page', params: { media_slug: media.slug } }" class="fw-bold">
                                                            {{ media.title }}
                                                        </router-link><br />
                                                        <span v-if="media.created_by">{{ $t('created-by') }} {{ media.created_by }}</span><br />
                                                        <span v-if="media.publish_date">{{ $t('published-on') }} {{ media.publish_date }}</span>
                                                    </div>
                                                    <Fav class="float-end" :loading="loading" :value="true" @input="unlikeMedia(media, index)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="pt-2">
                                        <span>{{ $t('you-havent-liked-any-media-items') }}</span>
                                    </div>
                                </div>
                                <div id="collections" role="tabpanel" aria-labelledby="collections-tab" class="tab-pane fade">
                                    <h5>{{ $t('here-you-can-quickly-access-the-collections-that-you-have-liked') }}</h5>
                                    <hr class="mb-1" style="opacity: 0.5; height: 2px;" />
                                    <table v-if="likedCollections.length > 0" class="table border-bottom">
                                        <tbody>
                                            <tr v-for="(collection, index) in likedCollections" :key="collection.id" style="border-bottom: 1px solid #5C6D80;">
                                                <td>
                                                    <router-link :to="{ name: 'show-network-collection-page', params: { collection_slug: collection.slug } }" class="fw-bold">
                                                        <div class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center rounded float-start me-4" style="height: 80px; width: 100px;">
                                                            <i class="fas fa-folder fa-2x"></i>
                                                        </div>
                                                    </router-link>
                                                    <div class="float-start">
                                                        <router-link :to="{ name: 'show-network-collection-page', params: { collection_slug: collection.slug } }" class="fw-bold">
                                                            {{ collection.name }}
                                                        </router-link><br />
                                                        <span v-if="collection.created_by">{{ $t('created-by') }} {{ collection.created_by }}</span><br />
                                                        <span v-if="collection.publish_date">{{ $t('published-on') }} {{ formatDate(collection.publish_date) }}</span>
                                                    </div>
                                                    <Fav class="float-end" :loading="loading" :value="true" @input="unlikeCollection(collection, index)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="pt-2">
                                        <span>{{ $t('you-havent-liked-any-collections') }}</span>
                                    </div>
                                </div>
                                <div id="courses" role="tabpanel" aria-labelledby="courses-tab" class="tab-pane fade">
                                    <h5>Here you can quickly access the courses that you have liked.</h5>
                                    <hr class="mb-1" style="opacity: 0.5; height: 2px;" />
                                    <table v-if="likedCourses.length > 0" class="table border-bottom">
                                        <tbody>
                                            <tr v-for="(course, index) in likedCourses" :key="course.id" style="border-bottom: 1px solid #5C6D80;">
                                                <td>
                                                    <router-link :to="{ name: 'view-course', params: { course_slug: course.slug } }" class="fw-bold">
                                                        <img v-if="course.thumbnail" :src="course.thumbnail" class="rounded float-start me-4" style="height: 80px; width: 100px;" />
                                                        <div v-else class="card-img-top text-primary py-2 d-flex align-items-center justify-content-center rounded float-start me-4" style="height: 80px; width: 100px;">
                                                            <i class='fas fa-folder fa-2x'></i>
                                                        </div>
                                                    </router-link>
                                                    <div class="float-start">
                                                        <router-link :to="{ name: 'view-course', params: { course_slug: course.slug } }" class="fw-bold">
                                                            {{ course.name }}
                                                        </router-link><br />
                                                        <span v-if="course.created_by">{{ $t('created-by') }} {{ course.created_by }}</span><br />
                                                    </div>
                                                    <Fav class="float-end" :loading="loading" :value="true" @input="unlikeCourse(course, index)" />
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <div v-else class="pt-2">
                                        <span>You haven't liked any courses.</span>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="row text-center mt-4">
                                <lottie-player
                                    autoplay
                                    loop
	                                speed="2.5"
                                    src="/img/animations/custom_loader.json"
                                    style="height: 130px;"
                                    >
                                </lottie-player>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/views/layouts/default/';
import Avatar from 'vue-avatar';
import Fav from '@/components/Fav.vue';
import moment from 'moment';

export default {
  components: {
    DefaultLayout,
    Avatar,
    Fav,
  },
    data() {
        return {
            busy: false,
            loading: false,
            likedNetworks: [],
            likedMedia: [],
            likedCollections: [],
            likedCourses: [],
        };
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            this.busy = true;
            this.$http.get('networks/likes').then(resp => {
                this.likedNetworks = resp.data.networks;
                this.likedMedia = resp.data.media;
                this.likedCollections = resp.data.collection;
                this.likedCourses = resp.data.courses;
                this.busy = false;
            });
        },
        fileIcon(extension) {
            switch (extension.toLowerCase()) {
                case 'pdf':
                    return 'fa-file-pdf';
                case 'doc':
                case 'docx':
                    return 'fa-file-word';
                case 'ppt':
                case 'pptx':
                    return 'fa-file-powerpoint';
                case 'xls':
                case 'xlsx':
                    return 'fa-file-excel';
                case 'csv':
                    return 'fa-file-csv';
                case 'zip':
                case 'rar':
                    return 'fa-archive';
                case 'png':
                case 'jpeg':
                case 'jpg':
                case 'heic':
                case 'svg':
                case 'gif':
                    return 'fa-file-image';
                case 'txt':
                    return 'fa-file-alt';
                default:
                    return 'fa-file';
            }
        },
        formatDate(date) {
            return moment(date).format('YYYY-MM-DD');
        },
        unlikeNetwork(network, index) {
            this.loading = true;
            // umami tracking for unlike network action
            if (window.umami && typeof window.umami.track === 'function') {
                window.umami.track(`unlike-network-${network.id}`, {
                    networkSlug: network.slug,
                });
            }
            this.$http.post('networks/' + network.slug + '/toggle-like').then(() => {
                this.likedNetworks.splice(index, 1);
                this.$swal.fire({
                    text: this.$t('removed-from-your-liked-networks'),
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                this.loading = false;
            });
        },
        unlikeMedia(media, index) {
            this.loading = true;
            // umami tracking for unlike media action
            if (window.umami && typeof window.umami.track === 'function') {
                window.umami.track(`unlike-media-${media.id}`, {
                    mediaSlug: media.slug,
                });
            }
            this.$http.post('networks/media/' + media.slug + '/toggle-like').then(() => {
                this.likedMedia.splice(index, 1);
                this.$swal.fire({
                    text: this.$t('removed-from-your-liked-media'),
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                this.loading = false;
            });
        },
        unlikeCollection(collection, index) {
            this.loading = true;
            // umami tracking for unlike collection action
            if (window.umami && typeof window.umami.track === 'function') {
                window.umami.track(`unlike-collection-${collection.id}`, {
                    collectionSlug: collection.slug,
                });
            }
            this.$http.post('networks/collection/' + collection.slug + '/toggle-like').then(() => {
                this.likedCollections.splice(index, 1);
                this.$swal.fire({
                    text: this.$t('removed-from-your-liked-collections'),
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                this.loading = false;
            });
        },
        unlikeCourse(course, index) {
            this.loading = true;
            // umami tracking for unlike course action
            if (window.umami && typeof window.umami.track === 'function') {
                window.umami.track(`unlike-course-${course.id}`, {
                    courseSlug: course.slug,
                });
            }
            this.$http.post('courses/' + course.slug + '/toggle-like').then(() => {
                this.likedCourses.splice(index, 1);
                this.$swal.fire({
                    text: "Removed from your liked courses",
                    position: 'bottom-end',
                    showConfirmButton: false,
                    timer: 2000,
                    timerProgressBar: true,
                });
                this.loading = false;
            });
        }
    },
};
</script>
<style scoped>
.nav .nav-item .active {
    background-color: #f7f7fc !important;
    border:0px !important;
    border-radius:0px;
    cursor: none;
    font-weight: bold;
}
.swal2-timer-progress-bar {
  background-color: #198754;
}
</style>